import { DialogActions } from './DialogActions';

// TODO: in v9, move styled() from DialogActions.jsx to here
export var StyledDialogActions = DialogActions;